<!-- Default Cell -->
<ng-template #cellTemplate let-row="row" let-column="column" let-index="index">
  @switch (column.render) {
    @case ('year') {
      <span>
        {{ !!row[column.property] ? row[column.property] : 'No Year' }}
      </span>
    }
    @case ('activity') {
      <span>
        <aa-activity
          class="activity no-padding"
          [activity]="row"
          [showAbstracts]="column.data.showAbstracts"
          [lazyLoadScholars]="column.data.lazyLoadScholars"
          [maxScholarsToDisplay]="maxScholarsToDisplay"
          [forceMapPeople]="forceMapPeople"
          [useArticleSubtypes]="false"
          [stopEventPropagationOnClick]="true"
          (showAllPeopleChange)="showPeople($event)"
          (showAllScholarsClick)="showAllCollaboratorsModal($event)"
          [excludeInstitutionName]="true"
          [hiddenFields]="hiddenFields"
        ></aa-activity>
      </span>
    }
  }
</ng-template>

<!-- Default Row -->
<ng-template
  #rowTemplate
  let-row="row"
  let-columns="columns"
  let-rowIndex="rowIndex"
>
  @for (column of columns; track column) {
    @if (column.render !== 'noRender') {
      <td [ngClass]="column.class" [ngStyle]="column.style">
        <ng-container
          [ngTemplateOutlet]="column.template ? column.template : cellTemplate"
          [ngTemplateOutletContext]="{
            row: row,
            column: column,
            index: rowIndex
          }"
        ></ng-container>
      </td>
    }
  }
</ng-template>

<!-- Default Body -->
<ng-template #bodyTemplate let-rows="rows" let-columns="columns">
  @for (activity of rows; track activity; let i = $index) {
    <!-- ternary operator is required for activity.class to ensure that
    [ngClass] always receives an array of strings if activity.class is undefined -->
    <tr
      [ngClass]="['cursor-pointer', activity.class ? activity.class : '']"
      [ngStyle]="activity.style"
      [class.view-edit-open]="activity.show"
    >
      <ng-container
        [ngTemplateOutlet]="rowTemplate"
        [ngTemplateOutletContext]="{
          row: activity,
          columns: columns,
          rowIndex: i
        }"
      ></ng-container>
    </tr>
  }
</ng-template>

<div class="flex column" style="margin-bottom: 10px">
  <div
    class="filter-row"
    [ngStyle]="{ padding: showDownloadButton ? '0 5px' : '0' }"
  >
    @if (showDownloadButton) {
      <button (click)="download()" (keyup.enter)="download()">
        <fa-icon [icon]="faDownload"></fa-icon> Download
      </button>
    }
    <app-search-bar
      [searchQuery]="activityQueryText"
      (searchQueryChange)="setSearchWithinResultsQuery($event)"
    ></app-search-bar>

    <app-activity-table-filter
      (applyButtonClicked)="updateRowsWithFilters(null, $event)"
      (cancelButtonClicked)="resetFilter()"
      (activityTypeSelected)="activityTypeFilterSelected($event)"
      (activityYearSelected)="activityYearFilterSelected($event)"
      [multiSelectActivityTypes]="multiSelectActivityTypes"
      [multiSelectActivityYears]="multiSelectActivityYears"
      [activitySearchFilterCounts]="activitySearchFilterCounts"
    ></app-activity-table-filter>
  </div>
</div>

<ng-template #headerTemplate let-column="column">
  @switch (column.render) {
    @default {
      <div>
        <span>{{ column.name }}</span>
      </div>
    }
  }
</ng-template>

<aa-data-table
  [columns]="_configuredColumns$ | async"
  [rows]="_filteredActivities$ | async"
  [page]="currentPage"
  [pageSize]="currentPageSize"
  [viewMode]="hasPagination ? 'paginate' : 'full'"
  [headerTemplate]="headerTemplate"
  [bodyTemplate]="bodyTemplate"
  (rowOrderChanged)="rowOrdersSorted($event)"
></aa-data-table>

@if (hasPagination && (_filteredActivities$ | async)?.length > 0) {
  <app-pagination-menu
    [(pageSize)]="currentPageSize"
    [(currentPage)]="currentPage"
    [numberOfRecords]="(_filteredActivities$ | async)?.length"
  ></app-pagination-menu>
}
